import ComboBoxItem from "components/ComboBox/ComboBoxItem";

const DATA_TYPE: ComboBoxItem<string>[] = [
  { id: 0, label: "BOOLEAN", value: "BOOL" },
  { id: 1, label: "UINT8", value: "UINT8" },
  { id: 2, label: "UINT16", value: "UINT16" },
  { id: 3, label: "UINT32", value: "UINT32" },
  { id: 4, label: "UINT64", value: "UINT64" },
  { id: 5, label: "INT8", value: "INT8" },
  { id: 6, label: "INT16", value: "INT16" },
  { id: 7, label: "INT32", value: "INT32" },
  { id: 7, label: "INT64", value: "INT64" },
  { id: 8, label: "FP16", value: "FP16" },
  { id: 9, label: "FP32", value: "FP32" },
  { id: 10, label: "FP64", value: "FP64" },
  { id: 11, label: "STRING", value: "BYTES" },
  { id: 12, label: "BF16", value: "BF16" },
];

export default DATA_TYPE;
